import { getSetting } from './settings.js';

let ctx;

function ensureCtx() {
  if (typeof window === 'undefined') return null;
  try {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function tone(freq, durationMs, options = {}) {
  if (!getSetting('sound')) return;
  const audio = ensureCtx();
  if (!audio) return;
  const now = audio.currentTime;
  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = options.type || 'sine';
  osc.frequency.setValueAtTime(freq, now);
  if (options.endFreq) {
    osc.frequency.exponentialRampToValueAtTime(options.endFreq, now + durationMs / 1000);
  }
  const peak = options.volume ?? 0.06;
  gain.gain.setValueAtTime(0, now);
  gain.gain.linearRampToValueAtTime(peak, now + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + durationMs / 1000);
  osc.connect(gain);
  gain.connect(audio.destination);
  osc.start(now);
  osc.stop(now + durationMs / 1000 + 0.05);
}

export function playStart() {
  tone(660, 120, { type: 'sine' });
  setTimeout(() => tone(880, 140, { type: 'sine' }), 90);
}

export function playStop() {
  tone(550, 130, { type: 'sine' });
  setTimeout(() => tone(440, 160, { type: 'sine' }), 100);
}

export function playComplete() {
  tone(523.25, 100, { type: 'triangle' });
  setTimeout(() => tone(659.25, 100, { type: 'triangle' }), 90);
  setTimeout(() => tone(783.99, 200, { type: 'triangle' }), 180);
}
